// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export const SDK_VERSION = "0.3.2";
export const DEFAULT_RETRY_POLICY_COUNT = 3;
